// `SortOrder`, in one place, because BOTH SHELLS HAVE TO AGREE ON IT.
//
// Every list the backend answers with — locations, rooms, a room's devices,
// common devices, favourites — carries a per-user `SortOrder`, and it is the
// order the customer arranged their own house in. It is DATA, not decoration.
//
// ⚠️ SORTING IT IS THE CLIENT'S JOB, and only the desktop shell was doing it.
// Three separate paths hand back rows in an order that is not `SortOrder`:
//
//   • the room reply is completed from the LOCATION reply (core/devices/roomMerge),
//     and the merged-in rows are appended — a sensor with SortOrder 2 lands last
//   • the offline cache (core/db/localRepo) reads IndexedDB, which answers in
//     KEY order; SortOrder survives on the row but nothing consults it
//   • an unfiltered admin read (browse-all) numbers SortOrder by arrival
//
// So "Sanjay Bedroom" listed its seven devices in the customer's order on
// desktop and in a different one on the phone. Nothing errors; the two screens
// simply disagree, and the phone is the one people use.
//
// `orderOf` tolerates the three spellings seen across the replies and treats a
// missing/NaN value as 0 rather than dropping the row to the end — a row with no
// SortOrder is unplaced, not last.

export const orderOf = (x) => Number(
  (x && (x.SortOrder ?? x.Sort_Order ?? x.sortorder)) ?? 0,
) || 0;

/**
 * A copy of `arr` in SortOrder.
 *
 * Stable, so rows sharing a SortOrder — which is common, since 0 is the default
 * for anything never reordered — keep the order the server sent them in rather
 * than shuffling between renders.
 */
export const sortByOrder = (arr) => (Array.isArray(arr)
  ? [...arr].sort((a, b) => orderOf(a) - orderOf(b))
  : []);

export default sortByOrder;
